exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error.error-3 .error-title {\n  font-size: 8.7rem !important; }\n\n@media (min-width: 768px) {\n  .error.error-3 .error-title {\n    font-size: 15.7rem !important; } }\n", ""]);

